import { fillUrlGuest } from "../../helpers/auto_url";

export default {
    login: { method: 'post', url: fillUrlGuest('login') },
    verifyConfirmation: { method: 'get', url: fillUrlGuest('verify_confirmation') },
    loadSession: { method: 'get', url: fillUrlGuest('load_session') },
    confirmation: { method: 'post', url: fillUrlGuest('confirmation') },
    createPassword: { method: 'post', url: fillUrlGuest('create_password') },
    forgotPassword: { method: 'get', url: fillUrlGuest('reset_password') },
    facebookLogin: { method:'post', url: fillUrlGuest('facebook') },
    facebookCheck:{method:'get','url':fillUrlGuest('facebook_verify')},
    loginGoogle: { method: 'post', url: fillUrlGuest('google_login') },
    authGoogle: { method: 'post', url: fillUrlGuest('google_callback') },
    loginX: { method: 'get', url: fillUrlGuest('x_login') },
    authX: { method: 'post', url: fillUrlGuest('x_callback') },
}

